
import Vue from 'vue'

export default Vue.extend({
  methods: {
    refreshApp() {
      this.$store.dispatch('sw/removeUpdateExists')
    },
  },
})
